import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { formatText,linkify } from '../../utility/MessageFormatter';

function AboutModal({botInfo, startChat, setOpenInfoModal, prefLang}) {
    return(
        <div className={`about-modal-wrapper ${startChat ? "in-chat" : ""}`}>
            <div className="modal-wrapper">
                <div className="m-header">
                    <h4>{botInfo?.data?.mobileAppConfig?.aboutUs ? botInfo?.data?.mobileAppConfig?.aboutUs?.[prefLang]?.title : "About Us"}</h4>
                    <CloseIcon onClick={()=> setOpenInfoModal(false)} />
                </div>
                <div className="m-body">
                    <p dangerouslySetInnerHTML={{ __html: linkify(formatText(botInfo?.data?.mobileAppConfig?.footerInfoMessage ? botInfo?.data?.mobileAppConfig?.footerInfoMessage?.[prefLang] : "crafted by"))}}></p>
                </div>
                <div className="m-footer">
                    <a className="btn-orange" target="_blank" href={botInfo?.data?.mobileAppConfig?.webUr ? botInfo?.data?.mobileAppConfig?.webUr : ""}>Ok</a>
                </div>
            </div>
        </div>
    )
}
export default AboutModal;
